import React from 'react';

const Standards = ({ t }) => {
  const standards = [
    { title: t.standards.design, description: t.standards.designDesc },
    { title: t.standards.construction, description: t.standards.constructionDesc },
    { title: t.standards.delivery, description: t.standards.deliveryDesc },
    { title: t.standards.scalability, description: t.standards.scalabilityDesc }
  ];

  return (
    <section data-testid="standards-section" className="py-12 sm:py-16 lg:py-20 bg-gray-50">
      <div className="container mx-auto px-5 sm:px-6 lg:px-8 max-w-6xl">
        {/* Mobile: Title above grid */}
        <div className="lg:hidden">
          <h2 className="text-xl sm:text-2xl font-light text-gray-900 mb-8 leading-snug">
            {t.standards.title}
          </h2>
          {/* Mobile image */}
          <div className="mb-8 -mx-5 sm:-mx-6 overflow-hidden">
            <img src="/images/renders/HA03b.jpg" alt="Hexaparks community pavilion" className="w-full h-[200px] sm:h-[260px] object-cover" />
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {standards.map((item, index) => (
              <div key={item.title}>
                <div className="w-6 h-px bg-gray-300 mb-4" />
                <h3 className="text-sm font-medium text-gray-900 mb-2">{item.title}</h3>
                <p className="text-sm text-gray-500 leading-relaxed">{item.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Desktop: Side by side */}
        <div className="hidden lg:grid lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-4">
            <h2 className="text-2xl xl:text-3xl font-light text-gray-900 leading-snug mb-6">
              {t.standards.title}
            </h2>
            <img src="/images/renders/HA03b.jpg" alt="Hexaparks community pavilion" className="w-full h-auto rounded-sm border border-gray-200" />
          </div>
          <div className="lg:col-span-8">
            <div className="grid grid-cols-2 gap-x-10 gap-y-8">
              {standards.map((item, index) => (
                <div key={item.title}>
                  <div className="w-6 h-px bg-gray-300 mb-4" />
                  <h3 className="text-sm font-medium text-gray-900 mb-2">{item.title}</h3>
                  <p className="text-sm text-gray-500 leading-relaxed">{item.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Standards;
